<template>
  <div>
    <l-control :position="position" class="leaflet-bar leaflet-control">
      <a href="#" @click="onToggleMode('plan')" title="Edit plan" :class="editPlan && 'on'">
        <i class="fa fa-map" />
      </a>
      <a href="#" v-if="editPlan" @click="onUploadTap" title="Upload plan">
        <i class="fa fa-upload" />
      </a>
      <a href="#" v-if="editPlan" @click="onToggle('show')" title="Toggle current plan" :class="!state.show && 'on'">
        <i class="fa fa-eye-slash" />
      </a>
    </l-control>
    <input ref="upload" type="file" @change="$emit('upload', $event)" accept="image/*" hidden />
  </div>
</template>

<script>
import {
  findRealParent,
  LControl
} from 'vue2-leaflet'

export default {
  props: {
    position: {
      type: String,
      default: 'topleft'
    },
    mode: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LControl
  },
  data () {
    return {
      state: {
        mode: '',
        show: this.show
      }
    }
  },
  watch: {
    mode () {
      this.setMode(this.mode)
    },
    show () {
      this.state.show = this.show
    }
  },
  async mounted () {
    this.map = findRealParent(this.$parent).mapObject
  },
  computed: {
    editPlan () {
      return this.state.mode.startsWith('plan')
    }
  },
  methods: {
    setMode (mode) {
      this.state.mode = this.mode
    },
    onToggle (name) {
      if (!(name in this)) return
      this.state[name] = !this.state[name]
      this.$emit(`toggle:${name}`, this.state[name])
    },
    onToggleMode (mode) {
      if (this.state.mode === mode) {
        this.state.mode = ''
      } else {
        this.state.mode = mode
      }
      this.$emit('change:mode', this.state.mode)
    },
    onUploadTap () {
      this.$refs.upload.click()
    }
  }
}
</script>

<style scoped>
a.on {
  background-color: #007bff;
}

a.on i.fa {
  color: white;
}
</style>
